var exports = {
  "k": "xf0b3b88a--1a7b5c--container",
};

module.exports = exports;
